import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6 text-right align-self-end" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "form-check" }
const _hoisted_11 = { class: "form-check" }
const _hoisted_12 = { class: "form-check" }

import { ref, computed, onMounted, watch } from 'vue'
    import type { Ref } from 'vue'
    import { useRoute } from 'vue-router'
    import CorporateNavigation from "@common/Components/CorporateNavigation.vue"

    import type { StrategySettingsReadModel } from '@Quest/Strategies/readmodels'

    import { useStrategySettingsQueryV1 } from '@Quest/Strategies/queries-vue-composables'
    import { useUpdateStrategySettingsCommandV1 } from '@Quest/Strategies/commands-vue-composables'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'StrategySettingsPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const strategyId = computed(() => String(route.params.strategyId ?? ''))

    const currencies = ['AUD', 'BRL', 'CAD', 'EUR', 'GBP', 'JPY', 'USD']

    const {
        runStrategySettingsQueryV1,
        modelStrategySettingsQueryV1
    } = useStrategySettingsQueryV1(workspaceId, strategyId)

    const rm = modelStrategySettingsQueryV1 as Ref<StrategySettingsReadModel | null>

    const {
        invokeUpdateStrategySettingsCommandV1,
        onSucceedUpdateStrategySettingsCommandV1,
        invokingUpdateStrategySettingsCommandV1
    } = useUpdateStrategySettingsCommandV1(workspaceId, strategyId)

    function handleUpdateStrategySettingsCommand()
    {
        if (!rm.value) return

        invokeUpdateStrategySettingsCommandV1({
            name: rm.value.Name,
            description: rm.value.Description,
            currency: rm.value.Currency,
            defaultPnlId: rm.value.DefaultPnlId,
            includeCogs: rm.value.IncludeCogs,
            includeOpex: rm.value.IncludeOpex,
            includeOther: rm.value.IncludeOther,
            fiscalYearStartMonth: rm.value.FiscalYearStartMonth
        })
    }

    onMounted(() =>
    {
        document.title = "Settings | TransparentChoice"
        runStrategySettingsQueryV1()
    })

    onSucceedUpdateStrategySettingsCommandV1(() =>
    {
        alert('Enterprise settings updated successfully')
        runStrategySettingsQueryV1()
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CorporateNavigation, { ActivePage: "dashboard" }),
    (_unref(rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-lg-6" }, [
              _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Settings")
            ], -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                role: "button",
                class: "btn btn-success",
                style: {"padding":"0.7em 2em"},
                onClick: handleUpdateStrategySettingsCommand,
                disabled: _unref(invokingUpdateStrategySettingsCommandV1)
              }, "Save", 8 /* PROPS */, _hoisted_4)
            ])
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_5, [
            _cache[7] || (_cache[7] = _createElementVNode("label", null, "Currency:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(rm).Currency) = $event)),
              class: "form-control"
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(currencies, (c) => {
                return _createElementVNode("option", { value: c }, _toDisplayString(c), 9 /* TEXT, PROPS */, _hoisted_6)
              }), 64 /* STABLE_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, _unref(rm).Currency]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[9] || (_cache[9] = _createElementVNode("label", null, "Financial Year Start Month:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(rm).FiscalYearStartMonth) = $event)),
              class: "form-control"
            }, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("option", { value: 1 }, "January", -1 /* CACHED */),
              _createElementVNode("option", { value: 2 }, "February", -1 /* CACHED */),
              _createElementVNode("option", { value: 3 }, "March", -1 /* CACHED */),
              _createElementVNode("option", { value: 4 }, "April", -1 /* CACHED */),
              _createElementVNode("option", { value: 5 }, "May", -1 /* CACHED */),
              _createElementVNode("option", { value: 6 }, "June", -1 /* CACHED */),
              _createElementVNode("option", { value: 7 }, "July", -1 /* CACHED */),
              _createElementVNode("option", { value: 8 }, "August", -1 /* CACHED */),
              _createElementVNode("option", { value: 9 }, "September", -1 /* CACHED */),
              _createElementVNode("option", { value: 10 }, "October", -1 /* CACHED */),
              _createElementVNode("option", { value: 11 }, "November", -1 /* CACHED */),
              _createElementVNode("option", { value: 12 }, "December", -1 /* CACHED */)
            ]))], 512 /* NEED_PATCH */), [
              [_vModelSelect, _unref(rm).FiscalYearStartMonth]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[10] || (_cache[10] = _createElementVNode("label", null, "Default P&L:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(rm).DefaultPnlId) = $event)),
              class: "form-control"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).Pnls, (t) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: t.Id
                }, _toDisplayString(t.Name), 9 /* TEXT, PROPS */, _hoisted_9))
              }), 256 /* UNKEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, _unref(rm).DefaultPnlId]
            ])
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("hr", { class: "my-4" }, null, -1 /* CACHED */)),
          _createElementVNode("fieldset", null, [
            _cache[14] || (_cache[14] = _createElementVNode("legend", null, "Project total cost", -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(rm).IncludeCogs) = $event)),
                id: "includeCogs"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelCheckbox, _unref(rm).IncludeCogs]
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("label", {
                class: "form-check-label",
                for: "includeCogs"
              }, " Include COGS ", -1 /* CACHED */))
            ]),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(rm).IncludeOpex) = $event)),
                id: "includeOpex"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelCheckbox, _unref(rm).IncludeOpex]
              ]),
              _cache[12] || (_cache[12] = _createElementVNode("label", {
                class: "form-check-label",
                for: "includeOpex"
              }, " Include OPEX ", -1 /* CACHED */))
            ]),
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(rm).IncludeOther) = $event)),
                id: "includeOther"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelCheckbox, _unref(rm).IncludeOther]
              ]),
              _cache[13] || (_cache[13] = _createElementVNode("label", {
                class: "form-check-label",
                for: "includeOther"
              }, " Include Other Expenses ", -1 /* CACHED */))
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})